import React, { useState } from 'react';
import { 
  FaArrowRight, 
  FaChevronRight,
  FaLinkedin, 
  FaEnvelope, 
  FaLightbulb,
  FaHandshake,
  FaRocket,
  FaXTwitter,
  FaStethoscope // Add a suitable medical-related icon instead of FaUserMd
} from 'react-icons/fa6';
import '../css/App.css'; // Global styles
import '../css/AboutStyles.css'; // Import redesigned styles
// Import team photos
import tomPhoto from '../assets/Tom.png'; // Tom's photo
import pavelPhoto from '../assets/Pavel.png'; // Pavel's photo

const About = () => {
  const [missionPage, setMissionPage] = useState(1);
  const [missionAnimating, setMissionAnimating] = useState(false);

  // Toggle between mission statement pages with animation
  const toggleMissionPage = () => {
    if (missionAnimating) return;
    setMissionAnimating(true);
    
    setTimeout(() => {
      setMissionPage(missionPage === 1 ? 2 : 1);
    }, 300);
    
    setTimeout(() => {
      setMissionAnimating(false);
    }, 600);
  };

  return (
    <div className="about-container">
      <div className="about-header">
        <h1>About MedMap</h1>
        <p className="about-subtitle">Empowering medical students with clarity and confidence in career planning</p>
      </div>

      <section className="mission-section">
        <div className="section-header">
          <FaRocket className="section-icon" />
          <h2>Our Mission</h2>
        </div>

        <div className={`mission-content ${missionAnimating ? 'fade-out' : 'fade-in'}`}>
          {missionPage === 1 ? (
            <div className="mission-card">
              <div className="mission-icon-container">
                <FaLightbulb className="mission-icon" />
              </div>
              <div className="mission-text">
                <h3>Guiding Your Medical Journey</h3>
                <p>
                  At <span className="highlight">MedMap</span>, we're dedicated to simplifying the complex journey through medical education. 
                  Our platform provides personalized guidance to help you navigate your path toward your ideal specialty.
                </p>
                <p>
                  We believe that with the right tools and information, every medical student can make confident, 
                  informed decisions about their career direction.
                </p>
              </div>
              <button 
                className="page-control" 
                onClick={toggleMissionPage}
                aria-label="View more about our mission"
              >
                <span>Read More</span>
                <FaChevronRight />
              </button>
            </div>
          ) : (
            <div className="mission-card">
              <div className="mission-icon-container">
                <FaHandshake className="mission-icon" />
              </div>
              <div className="mission-text">
                <h3>Built By Medical Professionals</h3>
                <p>
                  Our team combines experienced medical professionals and educators who understand 
                  the unique challenges students face when planning their careers.
                </p>
                <p>
                  We're committed to providing up-to-date, evidence-based resources that reflect 
                  current educational standards and make specialty matching accessible to everyone.
                </p>
              </div>
              <button 
                className="page-control back" 
                onClick={toggleMissionPage}
                aria-label="Return to previous mission statement"
              >
                <FaChevronRight className="rotate-180" />
                <span>Go Back</span>
              </button>
            </div>
          )}
        </div>
      </section>

      <section className="team-section">
        <div className="section-header">
          <FaStethoscope className="section-icon" /> {/* Replace FaUserMd with FaStethoscope */}
          <h2>Our Team</h2>
        </div>

        <div className="team-grid">
          <div className="team-card">
            <div className="team-photo">
              <img src={tomPhoto} alt="Tom Owen" className="team-member-image" />
            </div>
            <h3>Tom Owen</h3>
            <p className="team-role">Business Development Lead</p>
            <p className="team-bio">
              Medical student passionate about improving career guidance for other medical students
              through innovative technology solutions.
            </p>
            <div className="team-links">
              <a href="mailto:admin@medmap.uk" aria-label="Email Tom Owen">
                <FaEnvelope />
              </a>
              <a href="https://twitter.com/medmap_uk" target="_blank" rel="noopener noreferrer" aria-label="Tom Owen on X (Twitter)">
                <FaXTwitter />
              </a>
            </div>
          </div>

          <div className="team-card">
            <div className="team-photo">
              <img src={pavelPhoto} alt="Pavel Loginovic" className="team-member-image" />
            </div>
            <h3>Pavel Loginovic</h3>
            <p className="team-role">Technical Lead</p>
            <p className="team-bio">
              Full-stack developer with expertise in building educational platforms and data-driven 
              applications for healthcare.
            </p>
            <div className="team-links">
              <a href="mailto:admin@medmap.uk" aria-label="Email Pavel Loginovic">
                <FaEnvelope />
              </a>
              <a href="https://twitter.com/medmap_uk" target="_blank" rel="noopener noreferrer" aria-label="Pavel Loginovic on X (Twitter)">
                <FaXTwitter />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-section">
        <div className="section-header">
          <FaEnvelope className="section-icon" />
          <h2>Get In Touch</h2>
        </div>
        
        <div className="contact-content">
          <p>Have questions or feedback? We'd love to hear from you! Use our feedback widget or contact us directly.</p>
          <a href="mailto:admin@medmap.uk" className="contact-button">
            Contact Us
            <FaArrowRight className="btn-icon" />
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;